<template>
    <div>
        <a
            v-if="translatedTypes"
            :class="{ 'no-link': !object.url }"
            class="email-related-object"
            :href="object.url"
            target="_blank"
        >
            <div class="email-related-object__label typographies-paragraph-small-semibold">
                {{ EmailAttachTo }} :
            </div>
            <CompassIcon v-if="iconType" :icon="iconType" size="small" />
            <div class="email-related-object__object typographies-paragraph-small-semibold">
                {{ capitalizeFirstLetter }}
            </div>
        </a>
    </div>
</template>
<script>
export default {
    props: {
        object: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            EmailAttachTo: this.$t.__('email.EmailRelactedObject.attached_to'),
        };
    },
    computed: {
        translatedTypes() {
            switch (this.object.type) {
                case 'estimate':
                    return this.$t.__('email.EmailRelatedObject.estimate');
                case 'invoice':
                    return this.$t.__('email.EmailRelatedObject.invoice');
                case 'creditnote':
                    return this.$t.__('email.EmailRelatedObject.creditnote');
                case 'delivery':
                    return this.$t.__('email.EmailRelatedObject.delivery');
                case 'order':
                    return this.$t.__('email.EmailRelatedObject.order');
                case 'proforma':
                    return this.$t.__('email.EmailRelatedObject.proforma');
                case 'purInvoice':
                    return this.$t.__('email.EmailRelatedObject.purInvoice');
                case 'purCreditNote':
                    return this.$t.__('email.EmailRelatedObject.purCreditNote');
                case 'purOrder':
                    return this.$t.__('email.EmailRelatedObject.purOrder');
                case 'purDelivery':
                    return this.$t.__('email.EmailRelatedObject.purDelivery');
                case 'contact':
                    return this.$t.__('email.EmailRelatedObject.contact');
                case 'company':
                    return this.$t.__('email.EmailRelatedObject.company');
                case 'opportunity':
                    return this.$t.__('email.EmailRelatedObject.opportunity');
                case 'client':
                    return this.$t.__('email.EmailRelatedObject.client');
                case 'individual':
                    return this.$t.__('email.EmailRelatedObject.individual');
                default:
                    return '';
            }
        },
        iconType() {
            switch (this.object.type) {
                case 'estimate':
                case 'invoice':
                case 'creditnote':
                case 'delivery':
                case 'order':
                case 'proforma':
                case 'purInvoice':
                case 'purCreditNote':
                case 'purOrder':
                case 'purDelivery':
                    return 'obj-slsy-document';
                case 'contact':
                case 'client':
                case 'individual':
                    return 'obj-slsy-contact';
                case 'company':
                    return 'obj-slsy-company';
                case 'opportunity':
                    return 'obj-slsy-opportunity';
                default:
                    return '';
            }
        },
        capitalizeFirstLetter() {
            if (this.translatedTypes) {
                if (this.object.name) {
                    return this.translatedTypes + ' - ' + this.object.name;
                }

                return this.translatedTypes;
            }
            return {};
        },
    },
};
</script>
<style lang="scss" scoped>
.email-related-object {
    align-items: center;
    border: 1px solid var(--colors-common-border-lighter);
    border-radius: 4px;
    display: flex;
    gap: var(--spacing-0);
    margin: 0 0 var(--spacing-2);
    padding: var(--spacing-1);
    cursor: pointer;

    &__label {
        color: var(--colors-common-text-standard-default);
    }

    &__object {
        color: var(--colors-common-text-subtle-default);
    }
}
.email-related-object,
.no-link {
    cursor: default;
}
</style>
